import { DateTime } from 'luxon';

import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import AllInclusiveRoundedIcon from '@mui/icons-material/AllInclusiveRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';

import * as Yup from 'yup';

import RequestItems from './Components/RequestItems';
import RequestList from './Components/RequestList';
import ReturnWigs from './Components/ReturnWigs';
import ConsignedList from './Components/ConsignedList';
import UploadMethod from './Components/UploadMethod';


const headers = [
  {
    label: 'Shipment Num',
    id: 'shipment_num'
  },
  {
    label: 'Vendor',
    id: 'vendor'
  },
  // {
  //   label: 'Item Qty',
  //   id: 'item_qty'
  // },
  {
    label: 'Total Qty',
    id: 'total_qty'
  },
  {
    label: "Status",
    id: "status",
    multi: true,
    values: [{value: "accepted", status: "info"}, {value: "shipped", status: "secondary"}, {value: "pending", status: "warning"}, {value: "received", status: "success"}]
  },
  {
    label: "Type",
    id: "shipment_type",
    multi: true,
    values: [{value: "inbound", label: "Consignment", status: "success"}, {value: "outbound", label: "Return", status: "warning"}]
  },
  {
    label: "Entered",
    id: "generated",
  },
  {
    label: 'Date',
    date: true,
    id: 'date_created'
  }
];

const filters = [
  {
    id: "date_created",
    type: "date",
    label: "Date Created",
  }
]

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "toggle",
    name: "shipment_type",
    label: "Shipment Type",
    type: "text",
    options: [{value: "inbound", label: "Receive Consignment"}, {value: "outbound", label: "Return"}],
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    name: "shipment info",
    header: "Shipment Info",
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "debounceSearchSolo",
    formFieldType: "select",
    select: [],
    name: "vendor_id",
    label: "Select Vendor",
    url: "vendors",
    conditionStr: "&wholesale_vendor[$eq]=true",
    fieldName: "vendor_id",
    displayField: "brand_name",
    setDisplayField: "brand_name",
    formUpdates: [{name: "vendor_name", field: "brand_name"}],
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "formField",
    formFieldType: "date",
    name: "date_created",
    label: "Date",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  // {
  //   fieldType: "Component",
  //   Component: <RequestList />,
  //   name: "request_list",
  //   checkDisplayField: (values) => { return values?.shipment_type === "inbound"},
  //   size: {xs: 12, lg: 12}
  // },
  // { // not available now
  //   fieldType: "Component",
  //   Component: <ConsignedList />,
  //   name: "consigned_list",
  //   checkDisplayField: (values) => { return values?.shipment_type === "inbound"},
  //   size: {xs: 12, lg: 12}
  // },
  {
    fieldType: "divider",
    header: "Shipment Items",
    name: "shipment_items",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <UploadMethod />,
    name: "upload_method",
    checkDisplayField: (values) => { return values?.shipment_type === "inbound"},
    size: {xs: 12, md: 12}
  },
  // {
  //   fieldType: "Component",
  //   Component: <RequestItems />,
  //   name: "request_items",
  //   checkDisplayField: (values) => { return values?.shipment_type === "inbound"},
  //   size: {xs: 12, md: 12}
  // },
  {
    fieldType: "Component",
    Component: <ReturnWigs />,
    name: "return_wigs",
    checkDisplayField: (values) => { return values?.shipment_type === "outbound"},
    size: {xs: 12, md: 12}
  }
]

const initialValues = {
  shipment_type: 'inbound',
  shipment_num: '',
  vendor_id: '',
  date_created: DateTime.local(),
}
const initialValuesShipment = {
  shipment_type: 'inbound',
  shipment_num: '',
  vendor_id: '',
  date_created: DateTime.local(),
}

const initialValuesReturn = {
  shipment_type: 'inbound',
  shipment_num: '',
  vendor_id: '',
  date_created: DateTime.local(),
}

const additionalState = {
  items: [],
  wigs: [],
  vendor_name: '',
  vendor_wigs: [],
  entry: "manual"
}

const tabs = [
  {id: "all", label: "All", Icon: AllInclusiveRoundedIcon },
  {id: "inbound", label: "Consignments", Icon: Inventory2RoundedIcon },
  {id: "outbound", label: "Returns", Icon: LocalShippingRoundedIcon },
]

const schema = Yup.object().shape({
  vendor_id: Yup.string().required("Required"),
});

const parseData = (data) => {
  const parsed = {
    ...data,
  };
  parsed.date_created = DateTime.fromISO(data.date_created);
  parsed.vendor_id = data.vendor_id?.toString();
  return parsed
}

export {filters, headers, fields, initialValues, initialValuesShipment, tabs, schema, additionalState, parseData };
